import React, { useState } from "react";
import imageP from "../../assets/cirugia g.png";
import imageD from "../../assets/derma g.png";
import imageE from "../../assets/estetica g.png";
import imageT from "../../assets/trasplante g.png";
import CardReasonComponent from "./cardReason";
import "./styles.css";

const ThirdQuestionComponent = ({
  modalityAndSpecialtySelected,
  responseValidationAndGetData,
}) => {
  const [dermaReasonListVisible, setDermaReasonListVisible] = useState(false);
  const [esteticaReasonListVisible, setEsteticaReasonListVisible] =
    useState(false);
  const [plasticaReasonListVisible, setPlasticaReasonListVisible] =
    useState(false);
  const [capilarReasonListVisible, setCapilarReasonListVisible] =
    useState(false);

  const specialityList = responseValidationAndGetData?.specialityList;

  let dermatologiaReasonList;
  let esteticaReasonList;
  let plasticaReasonList;
  let capilarReasonList;

  const onClickDermatologia = () => {
    setDermaReasonListVisible(true);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(false);
  };

  const onClickEstetica = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(true);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(false);
  };

  const onClickPlastica = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(true);
    setCapilarReasonListVisible(false);
  };

  const onClickCapilar = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(true);
  };

  specialityList.map((item) => {
    let { id, reasonList } = item;
    switch (id) {
      case "01":
        dermatologiaReasonList = reasonList;
        break;
      case "02":
        esteticaReasonList = reasonList;
        break;
      case "04":
        plasticaReasonList = reasonList;
        break;
      case "06":
        capilarReasonList = reasonList;
        break;

      default:
        break;
    }
  });

  return (
    <div className="containerThirdQuestion">
      <h1 className="questionAppointment">Seleccione una especialidad</h1>
      <div className="cardsSpecialties">
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickDermatologia}
        >
          <img className="imageSpecialties" src={imageD} alt="Dermatología" />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Dermatología</div>
            <div className="specialityText">
              Todas las consultas dermatológicas{" "}
              <strong>tienen un coste de 110€</strong>. La valoración de caída
              capilar, alopecia, piel, manchas, cicatrices de acné, ajuste de
              rutina y cualquier otra consulta sobre piel, cabello, mucosas o
              uñas son consultas dermatológicas y por tanto
              <strong> tienen coste de 110€</strong> por consulta.
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickEstetica}
        >
          <img className="imageSpecialties" src={imageE} alt="Estética" />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Estética</div>
            <div className="specialityText">
              La visita informativa sobre tratamientos inyectables es gratuita.
              Se emitirá presupuesto personalizado y se valorará la idoneidad
              sobre el tratamiento de neuromoduladores, ácido hialurónico o
              estimuladores de colágeno. Cualquier otra consulta que no sea lo
              expresamente citado, o aquellas consultas sobre piel, láser, o
              cosmética <strong>tiene un coste de 110€</strong>. Seleccione
              “Dermatología” para estos casos.
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickCapilar}
        >
          <img
            className="imageSpecialties"
            src={imageT}
            alt="Trasplante capilar"
          />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Trasplante capilar</div>
            <div className="specialityText">
              Visita gratuita informativa con emisión de presupuesto.
              <br />
              <br />
              Para el diagnóstico y otros tratamientos de caída capilar o
              alopecia, selecciona cita en "Dermatología".
            </div>
          </div>
        </a>
      </div>

      <div id="CardReasonComponent">
        {(dermaReasonListVisible ||
          esteticaReasonListVisible ||
          plasticaReasonListVisible ||
          capilarReasonListVisible) && (
          <div>
            <CardReasonComponent
              dermaReasonListVisible={dermaReasonListVisible}
              esteticaReasonListVisible={esteticaReasonListVisible}
              plasticaReasonListVisible={plasticaReasonListVisible}
              capilarReasonListVisible={capilarReasonListVisible}
              dermatologiaReasonList={dermatologiaReasonList}
              esteticaReasonList={esteticaReasonList}
              plasticaReasonList={plasticaReasonList}
              capilarReasonList={capilarReasonList}
              modalityAndSpecialtySelected={modalityAndSpecialtySelected}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThirdQuestionComponent;
